import React from 'react';
import Styles from './styles.module.css';
import { personData } from 'src/type';
import { currentPersonAxes } from 'src/salon/desktop/3.recruit/personAxes';
type RecruitPagesPersonProps = {
  person: personData;
};

const SEVEN_SCALE = [0, 16, 32, 50, 66, 83, 100];

const toSevenScale = (value: number) => {
  let closestIndex = 0;
  let minDiff = Infinity;

  SEVEN_SCALE.forEach((v, i) => {
    const diff = Math.abs(v - value);
    if (diff < minDiff) {
      minDiff = diff;
      closestIndex = i;
    }
  });

  return closestIndex + 1;
};


// 求める人物像。白い1枚のカードに4つの軸を並べ、どちら寄りかを7段階の目盛りと丸で示す(学生アプリの ScoreRow と同じ。色はピンク1色)
const ACTIVE = "#ED7187";
const INACTIVE = "#FCD1D8";
const STRONG = "#C92D34";

type AxisRowProps = {
  title: string;
  value: number;
  leftLabel: string;
  rightLabel: string;
};

const AxisRow: React.FC<AxisRowProps> = ({ title, value, leftLabel, rightLabel }) => {
  const score = toSevenScale(value);
  const leanLeft = score < 4;
  const leanRight = score > 4;
  return (
    <div className={Styles.axis}>
      <div className={Styles.axis_title}>
        <span className={Styles.axis_dot} style={{ backgroundColor: ACTIVE }} />
        <h4>{title}</h4>
      </div>
      <div className={Styles.track}>
        {Array.from({ length: 7 }).map((_, i) => (
          <span key={i} className={Styles.track_seg} style={{ backgroundColor: INACTIVE }} />
        ))}
        <span
          className={Styles.marker}
          style={{
            left: `calc(${((score - 1) / 7) * 100}% + (100% / 7 - 16px) / 2)`,
            backgroundColor: ACTIVE,
            boxShadow: `0 1px 5px ${ACTIVE}4D`,
          }} />
      </div>
      <div className={Styles.axis_labels}>
        <h5 className={leanLeft ? Styles.label_strong : undefined} style={leanLeft ? { color: STRONG } : undefined}>{leftLabel}</h5>
        <h5 className={leanRight ? Styles.label_strong : undefined} style={leanRight ? { color: STRONG } : undefined}>{rightLabel}</h5>
      </div>
    </div>
  );
};

const RecruitPagesPerson: React.FC<RecruitPagesPersonProps> = ({ person }) => {
  return (
    <div className={Styles.person}>
      {/* 項目名・左右のラベルは定義表(src/salon/desktop/3.recruit/personAxes.ts)の今のバージョンから取る。 */}
      {currentPersonAxes().map(a => (
        <AxisRow key={a.key} title={a.title} value={100 - person[a.key].left} leftLabel={a.left} rightLabel={a.right} />
      ))}
    </div>
  );
};

export default RecruitPagesPerson;
